export enum FlexibilityLevel {
  NOT_FLEXIBLE = 1,
  SOMEWHAT_FLEXIBLE = 2,
  PRETTY_FLEXIBLE = 3,
}
